import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { UploadCloud, PencilRuler, Calculator, Box, Save, ArrowRight } from "lucide-react";

const steps = [
  { icon: PencilRuler, title: "Describe or draw", desc: "Configure your build — type, size, rooms, style, budget — or draw a floor plan on the blueprint canvas." },
  { icon: UploadCloud, title: "Or upload a blueprint", desc: "Drop in a floor plan, blueprint or rough sketch and let our AI read the layout for you." },
  { icon: Box, title: "Generate 3D", desc: "Get an interactive 3D model plus a photorealistic render of the finished building in seconds." },
  { icon: Calculator, title: "Get the full scope", desc: "AI produces national-average pricing split into material and labor across every scope of work." },
  { icon: Save, title: "Save & manage", desc: "Store projects in your portal, re-estimate as plans change, and track your portfolio value." },
];

export default function HowItWorks() {
  return (
    <div className="min-h-screen bp-grid">
      <Navbar />
      <section className="mx-auto max-w-5xl px-4 py-20 sm:px-8">
        <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-accent">How it works</p>
        <h1 className="mt-2 font-heading text-4xl font-extrabold tracking-tighter sm:text-5xl lg:text-6xl">
          From idea to build-ready in five steps.
        </h1>

        <div className="mt-14 space-y-px">
          {steps.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, x: -12 }} whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.06 }}
              className="flex items-start gap-6 border border-border p-7 transition-colors hover:bg-secondary/20"
              data-testid={`step-${i}`}>
              <span className="font-mono2 text-3xl font-bold text-primary">0{i + 1}</span>
              <div className="flex h-11 w-11 shrink-0 items-center justify-center border border-border bg-secondary/40">
                <s.icon className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h3 className="font-heading text-xl font-semibold">{s.title}</h3>
                <p className="mt-1 text-muted-foreground">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/generate" data-testid="hiw-generate">
            <Button size="lg" className="rounded-sm bg-primary font-mono2 uppercase tracking-widest text-black hover:bg-primary/90">
              Try the 3D Generator <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Link to="/register">
            <Button size="lg" variant="outline" className="rounded-sm border-border font-mono2 uppercase tracking-widest">Start Free</Button>
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
